const BUSINESS_TYPES = [
  {
    label: "農業商人 / 農場店",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "動物保護施設 / チャリティ",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "育成牛飼育場",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "牛肉生産者",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "ブロイラー", value: "Broilers", id: "broilers" },
  {
    label: "購買グループ",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "子牛生産",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "子牛牧場/育成者",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "牛買い付け業者", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "契約栽培者",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "協同組合", value: "Cooperative", id: "cooperative" },
  {
    label: "本社",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "繁殖牛/子牛飼育",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "酪農生産",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "販売業者 / 代理店",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "飼料工場", value: "Feed Mill", id: "feed_mill" },
  { label: "肥育場", value: "Feedyard", id: "feedyard" },
  {
    label: "育成者/育成場",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "孵化場", value: "Hatchery", id: "hatchery" },
  {
    label: "未経産牛生産",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "採卵鶏統合",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "採卵鶏", value: "Layers", id: "layers" },
  { label: "メディア", value: "Media", id: "media" },
  {
    label: "牛乳協同組合/買い付け業者",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "混合/その他の生産者",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "栄養剤供給業者",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "加工業者/処理業者",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "ペット小売店",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "薬局", value: "Pharmacy", id: "pharmacy" },
  {
    label: "家禽育種家",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "家禽統合業者",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "羊生産者", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "肥育牛飼育",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "家畜市場/競売場",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "豚生産者", value: "Swine Producer", id: "swine_producer" },
  { label: "七面鳥", value: "Turkeys", id: "turkeys" },
  {
    label: "大学 / 教育機関",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "獣医診療所",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "卸売業者 / 小売業者",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "羊毛買い付け業者", value: "Wool Buyer", id: "wool_buyer" },
];
const FIELDS = {
  common: {
    errors: {
      required: "必須",
    },
  },
  salutation: {
    label: "敬称",
    placeholder: "敬称を選択",
    errors: {
      required: "敬称は必須です",
      invalid: "有効な敬称を選択してください",
    },
  },
  firstName: {
    label: "名",
    placeholder: "ジョン",
    errors: {
      required: "名は必須です",
      minLength: "名は2文字以上である必要があります",
      maxLength: "名は50文字以下である必要があります",
    },
  },
  lastName: {
    label: "姓",
    placeholder: "ドウ",
    errors: {
      required: "姓は必須です",
      minLength: "姓は2文字以上である必要があります",
      maxLength: "姓は50文字以下である必要があります",
    },
  },
  email: {
    label: "Eメール",
    placeholder: "john.smith@example.org",
    description:
      "共有メールアドレスではなく、個人用のメールアドレスを入力してください。",
    prefixWarningTitle: "共有メールボックスが検出されました",
    prefixWarningDescription:
      "優れたパーソナライズされた体験のために、個人のEメールアドレスを使用することをお勧めします",
    errors: {
      required: "Eメールは必須です",
      invalidEmail: "有効なEメールアドレスを入力してください",
      emailAssociatedWithYourAccount:
        "お客様のメールアドレスはアカウントに関連付けられており、変更できません。",
    },
  },
  confirmEmail: {
    label: "Eメール確認",
    placeholder: "john.smith@example.org",
    errors: {
      required: "Eメール確認は必須です",
      invalidEmail: "有効なEメールアドレスを入力してください",
      emailMatchError: "Eメールアドレスが一致しません",
    },
  },
  password: {
    label: "パスワード",
    placeholder: "パスワードを入力してください",
    errors: {
      required: "パスワードは必須です",
    },
  },
  confirmPassword: {
    label: "パスワード確認",
    placeholder: "パスワードを確認してください",
    errors: {
      required: "パスワード確認は必須です",
      passwordMatchError: "パスワードが一致しません",
    },
  },
  addressLine1: {
    label: "住所1",
    placeholder: "メインストリート123",
    errors: {
      required: "住所1は必須です",
      minLength: "住所1は5文字以上である必要があります",
      maxLength: "住所1は100文字以下である必要があります",
    },
  },
  addressLine2: {
    label: "住所2",
    placeholder: "アパート4B",
    errors: {
      required: "住所2は必須です",
      maxLength: "住所2は100文字以下である必要があります",
    },
  },
  city: {
    label: "市 / 町",
    placeholder: "スプリングフィールド",
    errors: {
      required: "市 / 町は必須です",
      minLength: "市 / 町は2文字以上である必要があります",
      maxLength: "市 / 町は50文字以下である必要があります",
    },
  },
  state: {
    label: "州",
    placeholder: "州を選択",
    errors: {
      required: "州は必須です",
      invalid: "有効な州を選択してください",
    },
  },
  zipCode: {
    label: "郵便番号",
    placeholder: "12345",
    errors: {
      required: "郵便番号は必須です",
      invalid: "有効な郵便番号を入力してください",
    },
  },
  role: {
    label: "役割",
    placeholder: "あなたの役割を選択",
    errors: {
      required: "あなたの役割を選択してください",
      invalid: "有効な役割を選択してください",
    },
  },
  businessType: {
    label: "事業の種類",
    placeholder: "事業の種類を選択",
    errors: {
      required: "事業の種類は必須です",
      invalid: "有効な事業の種類を選択してください",
    },
  },
  businessName: {
    label: "会社名",
    placeholder: "会社名を入力",
    errors: {
      required: "会社名は必須です",
      minLength: "会社名は2文字以上である必要があります",
      maxLength: "会社名は100文字以下である必要があります",
    },
  },
  businessSearch: {
    label: "会社検索:",
    addNewAccount: "新しいビジネスアカウントを追加",
    canNotFindBusiness: "あなたの会社が見つかりませんか？",
    guideline: "郵便番号を入力し、以下のリストから選択してください。",
    guidelineForNameSearch:
      "会社名をフルで入力し、リストから選択してください。",
    placeholder: "どこで働いていますか？",
    noResults: "結果が見つかりません",
    searching: "検索中...",
    selectedBusinessHeading: "選択された会社:",
    selectedBusinessNotCorrect: "違いますか？",
    selectedBusinessTryAgain: "もう一度試す",
    selectedBusinessDismiss: "会社を却下",
    resultsFound: {
      singular: "1件の会社が見つかりました",
      plural: "複数の会社が見つかりました",
    },
    errors: {
      network:
        "会社検索ファインダーへの接続に問題が発生しています。後でもう一度お試しください。",
    },
  },
  explicitConsent: {
    label:
      "このボックスにチェックを入れることにより、私はエランコの使用条件に同意し、エランコがエランコのプライバシー通知に従って私の個人情報を収集および処理することを認めます",
    errors: {
      required: "Eメールの同意は必須です",
    },
  },
  telephone: {
    label: "携帯電話番号",
    placeholder: "携帯電話番号を入力してください:",
    dialCodeLabel: "コード",
    dialCodePlaceholder: "国を検索",
    errors: {
      invalid: "有効な電話番号を入力してください。",
    },
  },
  professionalNumber: {
    label: "職業番号",
    placeholder: "1234567",
    errors: {
      required: "職業番号を入力してください",
      maxLength: "入力が文字制限を超えています",
    },
  },
  addressSearch: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  businessSearchField: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  checkbox: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  checkboxGroup: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  combobox: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  datePicker: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  dateRange: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  dateTime: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  emailField: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  fileInput: {
    errors: {
      required: "ファイルを選択してください",
    },
  },
  number: {
    errors: {
      required: "数字を入力してください",
      minValue: "最小値よりも高い値を入力してください",
      maxValue: "最大値よりも低い値を入力してください",
    },
  },
  passwordField: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  rangeSlider: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  select: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  telephoneField: {
    errors: {
      required: "数字のみを入力してください",
      invalidTelephone: "有効な電話番号を入力してください",
      invalidFormat: "無効な数値形式です",
    },
  },
  text: {
    errors: {
      required:
        "文字 (A-Z)、数字 (0-9) のみを使用し、記号は使用しないでください",
      maxLength: "入力が文字数制限を超えています",
      minLength: "入力は2文字以上である必要があります",
    },
  },
  textarea: {
    characters: "文字",
  },
  time: {
    errors: {
      required: "このフィールドは必須です",
    },
  },
  form: {
    errors: {
      generic: "フォームの送信中にエラーが発生しました。再度お試しください。",
      reportAnIssue: "問題を報告してください。",
      configuration: "設定エラー",
      noFormQuestionsAvailable: "フォームの質問が利用できません。",
      formComponentLoad:
        "サポートされていないフィールドのため、フォームコンポーネントを読み込めませんでした。",
      code: "コード",
      type: "タイプ",
    },
  },
};
const ROLES = [
  { value: "Academic", label: "学者", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "動物福祉 - その他",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "動物福祉 - 小売スタッフ",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "動物福祉 - 獣医",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "動物福祉 - 獣医看護師",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "動物福祉 - ボランティア",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "牛肉 / 肥育場普及員",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "牛肉生産者",
    id: "beef_producer",
  },
  { value: "Breeder", label: "ブリーダー", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "ビジネス管理者 / 受付",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "事業主 / パートナー",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "コンサルティング栄養士",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "企業従業員（獣医師以外）",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "酪農生産者",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "販売業者", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "販売担当者、フィールドベース",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "販売担当者、インサイド",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "教育機関 - 高校生",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "教育機関 - TAFE学生",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "教育機関 - 大学生",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "トリマー", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "医療 / クリニックディレクター",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "栄養 / 飼料販売",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "栄養専門家",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "栄養士", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "オフィス / 診療所管理者",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC小売業者", id: "otc_retailer" },
  { value: "Pharmacist", label: "薬剤師", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "薬局 - スタッフ",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "豚生産者", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "家禽生産者",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "診療所オーナー（獣医師以外）",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "受付 / 顧客サービス",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "再販店 - スタッフ",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "学生RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "獣医",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "トレーナー", id: "trainer" },
  { value: "Veterinarian", label: "獣医", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "獣医、診療所オーナー",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "獣医助手",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "獣医看護師",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "獣医診療所 - その他",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "獣医診療所 - 獣医",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "獣医診療所 - 獣医看護師",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "獣医専門医",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "獣医学生",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "獣医外科医",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "獣医技術者",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "卸売業者", id: "wholesaler" },
];
const SALUTATIONS = [
  {
    label: "博士",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "ミス",
    value: "Miss",
    id: "miss",
  },
  {
    label: "氏",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "夫人",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "様",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "教授",
    value: "Professor",
    id: "professor",
  },
];
export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
